import { render, staticRenderFns } from "./MadeReturn.vue?vue&type=template&id=634b1811&"
import script from "./MadeReturn.vue?vue&type=script&lang=js&"
export * from "./MadeReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports